export default __webpack_public_path__ + "78d0ba8c3b247ba6ac335d29d7a399da.png";